<template>
    <div class="space-y-2">
        <form-select name="Target object" :model-value="targetValue" @update:model-value="setTarget">
            <option value="">Select target…</option>
            <option v-if="missingTarget" :value="targetValue">{{ targetValue }} — unavailable</option>
            <option v-for="target in targets" :key="target.value" :value="target.value">{{ target.label }}</option>
        </form-select>
        <form-select name="Property" :model-value="propertyValue" @update:model-value="setProperty">
            <option value="">Select property…</option>
            <option v-if="missingProperty" :value="propertyValue">{{ propertyValue }} — unavailable</option>
            <option v-for="property in properties" :key="property.key" :value="property.key">{{ property.label }}</option>
        </form-select>
        <ActionPropertyValueEditor v-if="selectedProperty" :model-value="action.value"
            :property-definition="selectedProperty" :context-variables="contextVariables"
            @update:model-value="setValue" />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { getActionSettableProperties, resolveActionProperty } from '../../../actions/actionPropertyResolver.js';
import { variablesAcceptedByProperty } from '../../../actions/actionContextResolver.js';
import ActionPropertyValueEditor from './ActionPropertyValueEditor.vue';

const props = defineProps({
    node: { type: Object, required: true }, handler: { type: Object, required: true },
    action: { type: Object, required: true }, targets: { type: Array, required: true },
});
const emit = defineEmits(['change']);
const targetValue = computed(() => props.action.target ? `${props.action.target.pageId}:${props.action.target.objectId}` : '');
const selectedTarget = computed(() => props.targets.find(target => target.value === targetValue.value)?.node);
const properties = computed(() => getActionSettableProperties(selectedTarget.value));
const selectedProperty = computed(() => resolveActionProperty(selectedTarget.value, props.action.property));
const propertyValue = computed(() => props.action.property
    ? `${props.action.property.part ?? 'object'}:${props.action.property.name}`
    : '');
const missingTarget = computed(() => targetValue.value && !selectedTarget.value);
const missingProperty = computed(() => propertyValue.value && !selectedProperty.value);
const contextVariables = computed(() =>
    variablesAcceptedByProperty(props.node, props.handler.event, selectedProperty.value));

function setTarget(value) {
    const [pageId, objectId] = value.split(':').map(Number);
    props.action.target = value ? { pageId, objectId } : null;
    // Keep an existing property/value when the target is temporarily changed
    // to a different type (notably Range -> non-Range). The resolver marks it
    // unavailable and the editor shows that state; switching back restores it.
    emit('change');
}
function setProperty(key) {
    const property = properties.value.find(item => item.key === key);
    props.action.property = property ? { ...property.property } : null;
    props.action.value = property?.default ?? '';
    emit('change');
}
function setValue(value) {
    props.action.value = value;
    emit('change');
}
</script>
